/**
 * represents the rating of the user
 */
export enum UserRating {
    Like = "like",
    Dislike = "dislike",
    None = "none",
}